import { render, staticRenderFns } from "./close-button.svg.vue?vue&type=template&id=1da6fe24&"
import script from "./close-button.svg.vue?vue&type=script&lang=js&"
export * from "./close-button.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports